import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=a78bc312&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=a78bc312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78bc312",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a78bc312')) {
      api.createRecord('a78bc312', component.options)
    } else {
      api.reload('a78bc312', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=a78bc312&scoped=true&", function () {
      api.rerender('a78bc312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8yTGsC3KNrZCa/JS/comp/PopupDialog.vue"
export default component.exports